"use client";

import { type AccessTokenPayload, AuthenticationProvider } from "@pharaday/auth";
import { FeatureFlagContainer, FeatureFlagIdentificationService } from "@pharaday/feature-flag";
import { LighthouseProvider, TopLoadingBar } from "@pharaday/lighthouse";
import { getQueryClient } from "@pharaday/utils";
import { QueryClientProvider } from "@tanstack/react-query";
import { type PropsWithChildren } from "react";
import "reflect-metadata";

type ClientProvidersProps = PropsWithChildren;

const ClientProviders = ({ children }: ClientProvidersProps) => {
  const queryClient = getQueryClient();

  const handleAuthenticated = (payload: AccessTokenPayload) => {
    FeatureFlagContainer.get(FeatureFlagIdentificationService).identify(payload.id, {
      organizationId: payload.organizationId,
    });
  };

  const handleUnauthenticated = () => {
    FeatureFlagContainer.get(FeatureFlagIdentificationService).reset();
  };

  return (
    <LighthouseProvider>
      <QueryClientProvider client={queryClient}>
        <AuthenticationProvider
          signOutRedirectUrl="/login"
          onAuthenticated={handleAuthenticated}
          onUnauthenticated={handleUnauthenticated}
        >
          <TopLoadingBar />
          {children}
        </AuthenticationProvider>
      </QueryClientProvider>
    </LighthouseProvider>
  );
};

export default ClientProviders;
